import { RootStateOrAny } from 'react-redux'

import { actionTypes } from 'actions/actionTypes'
import { getIsAuthenticated } from 'selectors/auth'
import { getPromoCode } from 'selectors/basket'
import { getIsDiscountOptimisationEnabled } from 'selectors/features'

import { DISCOUNT_OPTIMISATION_PROMO_CODE_DATA, PROMO_CODE_DATA } from './homeConfig'

export const getPromoBannerState = (state: RootStateOrAny) => {
  const basketPromoCode = getPromoCode(state)
  const currentPromo = state.promoCurrent || basketPromoCode || ''
  const isAuthenticated = getIsAuthenticated(state)
  const isDiscountOptimisationEnabled = getIsDiscountOptimisationEnabled(state)
  const promoCodeData = isDiscountOptimisationEnabled
    ? DISCOUNT_OPTIMISATION_PROMO_CODE_DATA
    : PROMO_CODE_DATA

  const discountPromo = promoCodeData.defaultPromoCode

  const promoText = promoCodeData.defaultBannerText

  const hasCurrentPromo = currentPromo.length > 0

  const hasError =
    !!state.error.get(actionTypes.PROMO_GET) || !!state.error.get(actionTypes.PROMO_APPLY)

  const hide = isAuthenticated || hasError || hasCurrentPromo

  const canApplyPromo = !hide

  return {
    promoCode: discountPromo,
    canApplyPromo,
    promoText,
  }
}
